module.exports = __webpack_public_path__ + "static/media/pl-PL.92565605.md";